import React, { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { ActivityIndicator } from '@kontentino/ui';
import routeConfig from 'app/config/routes';

const VerifyEmail = lazy(() => import('./pages/VerifyEmail'));

export const verifyEmailRouter: RouteObject = {
  path: routeConfig.verifyEmail.path,
  element: (
    <Suspense
      fallback={
        <div className="tw-flex tw-h-full tw-items-center tw-justify-center">
          <ActivityIndicator />
        </div>
      }
    >
      <VerifyEmail />
    </Suspense>
  ),
};
